import React from 'react';
import { bool, shape, string } from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { IconSvg } from '@ajaibid/components';
import {
  styAccountIcon,
  styAccountInfo,
  styAccountName,
  styAccountPrimeBadge,
  styAccountUser,
  styAccountWrapper,
  styImgAccount,
} from './style';

const Account = ({ imgProfile, isPremium, isPremiumTrial, userData }) => {
  const navigate = useNavigate();
  return (
    <div
      className={styAccountWrapper}
      onClick={() => {
        navigate('/account-detail');
      }}
    >
      <div className={styAccountInfo}>
        <img src={imgProfile} alt={imgProfile} className={styImgAccount} />
        <div className={styAccountName}>
          <span className={styAccountUser}>
            {userData?.user_info?.first_name || 'Investor Ajaib'}
          </span>
          {(isPremium || isPremiumTrial) && <span className={styAccountPrimeBadge}>prime</span>}
        </div>
      </div>
      <div className={styAccountIcon}>
        <IconSvg.Chevron.Right />
      </div>
    </div>
  );
};

Account.defaultProps = {
  imgProfile: '',
  isPremium: false,
  isPremiumTrial: false,
  userData: {},
};

Account.propTypes = {
  imgProfile: string,
  isPremium: bool,
  isPremiumTrial: bool,
  userData: shape({}),
};

export default Account;
